module.exports = __webpack_public_path__ + "static/media/background.328f9c92.webp";